module.exports = function() {
    if (!document.getElementsByClassName('activate-vertical-carousel')[0]) return;

    var isMobile = ICF.Utils.DeviceDetection.IsMobile();
    var mySwiper;

    var state = {
        mobileSwiper: false,
        desktopSwiper: false,
        direction: 'horizontal',
        isMobile: function () {
            return ICF.Utils.DeviceDetection.IsMobile();
        },

        setCurrentState: function () {
            state.mobileSwiper = isMobile;
            state.desktopSwiper = !isMobile;
            state.direction = 'horizontal';
        }
    };

    var swiperObj = {
        $swiperContainer: jQuery('.activate-vertical-carousel .swiper-container'),
        init: function () {
            swiperObj.swiper();

            if (state.isMobile()) {
                ICF.Utils.EqualHeights.SetEqualHeights(this.$swiperContainer.find('.vertical-carousel-content'));
            } else {
                this.$swiperContainer.find('.vertical-carousel-content').height('auto');
            }
        },

        swiper: function () {
            this.$swiperContainer.removeClass('swiper-container-vertical').addClass('swiper-container-horizontal');
            this.createSwiper();
        },

        createSwiper: function () {
            if (mySwiper) {
                mySwiper.destroy(true, true);
                mySwiper = undefined;
            }

            mySwiper = new Swiper('.activate-vertical-carousel .swiper-container', {
                direction: state.direction,
                loop: false,
                speed: 500,
                paginationClickable: true,
                navigation: {
                    nextEl: '.swiper-button-next-custom',
                    prevEl: '.swiper-button-prev-custom',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                grabCursor: true
            });
        }
    }

    state.setCurrentState();
    swiperObj.init();

    var resizePods = ICF.Utils.Debounce(function () {
        state.setCurrentState();
        swiperObj.init();
    }, 250)

    window.addEventListener('resize', resizePods);
};